@if (!schedule().hasTimesheet) {
  <div class="timesheet__item timesheet__status timesheet__status--declined timesheet-column--status"></div>
}
@if (schedule().hasTimesheet) {
  <div
    class="timesheet__item timesheet__status timesheet-column--status"
    [ngClass]="{
      'timesheet__status--approved': schedule().timesheet?.status === 'Approved',
      'timesheet__status--declined': schedule().timesheet?.status === 'Declined',
      'timesheet__status--pending': schedule().timesheet?.status === 'Pending',
    }"
  ></div>
}

<div class="timesheet__item timesheet-column--start">
  {{ schedule().starttime | time }}
</div>

@if (!schedule().hide_end_time) {
  <div class="timesheet__item timesheet-column--end">
    {{ schedule().endtime | time }}
  </div>
}
@if (schedule().hide_end_time) {
  <div class="timesheet__item timesheet-column--end">---</div>
}

@if (cols()?.break) {
  <div class="timesheet__item timesheet-column--break">
    {{ schedule().break }}
  </div>
}

@if (cols()?.paidBreak) {
  <div class="timesheet__item timesheet-column--paid-break">
    {{ schedule().paid_break }}
  </div>
}

@if (cols()?.location) {
  <location-info [department]="department()" [locations]="locations()"> </location-info>
}

@if (cols()?.department) {
  <div class="timesheet__item timesheet-column--department">
    <timesheet-info [text]="department().name"></timesheet-info>
  </div>
}
@if (cols()?.team) {
  <div class="timesheet__item timesheet-column--team">
    <timesheet-info [text]="schedule().Team?.name"></timesheet-info>
  </div>
}
@if (cols()?.shift) {
  <div class="timesheet__item timesheet-column--shift">
    <timesheet-info [text]="schedule().Shift?.long_name"></timesheet-info>
  </div>
}

<!--
  A schedule has nothing to show in the columns below, but the cells still have to
  be here: the details column that follows lines up with the header's only while
  every row in front of it declares the same columns.
-->
@if (cols()?.surcharge) {
  <div class="timesheet__item timesheet-column--surcharge"></div>
}
@if (cols()?.km) {
  <div class="timesheet__item timesheet-column--km"></div>
}
@if (cols()?.meals) {
  <div class="timesheet__item timesheet-column--meals"></div>
}
@if (cols()?.note) {
  <div class="timesheet__item timesheet-column--note"></div>
}
@for (customField of customFields(); track customField.id) {
  @if (customFieldCols()?.[customField.id]) {
    <div class="timesheet__item" [style.width.px]="customField.width"></div>
  }
}

<div class="timesheet__item timesheet__details timesheet-column--details">
  <span class="timesheet__schedule-label">{{ 'Scheduled' | translate }}</span>
</div>
